
import React from 'react'
import { Avatar } from 'antd';
import Sub from './sub';
import Favorite from './favorite';
import Feedback from './feedback';
import Config from "../../config/Config";
import WidgetAjax from '../../widget/WidgetAjax';
import { UserOutlined } from '@ant-design/icons';
import { checkLogin } from '../../pages/com/utils';
let path = Config.getBasePath();
let filePath = Config.getFilePath();

class personalCenter extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      analyse: [
        { name: '求职反馈', num: '0', value: '1' },
        { name: '我的投递', num: '0', value: '2' },
        { name: '我的收藏', num: '0', value: '3' }
      ],
      analysValue: "1",
    }
  }
  async componentDidMount() {
    this.getUserInfo();
  }

  componentWillUnmount() {

  }

  getUserInfo = () => {
    const onUserInfo = (res) => {
      if (res.status == 0) {
        this.setState({ user: res.result });
        this.summary();
      }
    }
    WidgetAjax.ajax({ url: path + '/applicant/resume_info', params: {}, callback: onUserInfo });

  }

  /**
   * 用户收藏 投递 面试 数量
   */
  summary = () => {

    const onSummary = (res) => {
      if (res.status == 0) {
        let data = res.result;
        this.setState({
          analyse: [
            { name: '求职反馈', num: data?.interviews + "" || '0', value: '1' },
            { name: '我的投递', num: data?.applications + "" || '0', value: '2' },
            { name: '我的收藏', num: data?.favors + "" || '0', value: '3' }
          ]
          ,
          statistic:data
        })
      }
    }

    WidgetAjax.ajax({ url: path + '/applicant/summary', params: {}, callback: onSummary });
  }


  /**
  * 跳转简历
  */
  resume = () => {
    if (checkLogin()) {
      this.props.history.push({ pathname: "/home/resume" });
    } else {
      this.logOut("/home/resume");
    }
  }


  render() {
    const { user, analyse, analysValue , statistic=undefined } = this.state;

    return <div component-data="personalCenter">
      <div className='screen'>
        <div className='head_filter'>
          <div className='box_1200'>
            <div className='user_info_box'>
              {
                user && user.LOGO ?
                  <img className='user_logo' src={filePath + 'applicant/'+ user?.id +'/M' + user?.LOGO[0] + '.png'} />
                  : <Avatar shape="square" className='user_logo' size={100} icon={<UserOutlined />} />
              }
              <div className='user_head'>
                <div className='user_name_box'>
                  <div className='user_name'>{user?.PERNAME || '未填写名称'}</div>
                  <div className='user_edit_link'>
                    【<div className='resume_link'><img src={require("../../img/pinzhunzhun/personalCenter/icon-resume.png")} /> <a onClick={() => this.resume()}>编辑简历</a></div>】
                  </div>
                </div>

                <div className='resume_op'>
                  {/* <div className='resume_op_item'>
                    <img src={require("../../img/pinzhunzhun/personalCenter/icon-refresh.png")} />
                    简历刷新
                  </div>
                  <div className='resume_op_item'>
                    <img src={require("../../img/pinzhunzhun/personalCenter/icon-record.png")} />
                    个人档案
                  </div> */}
                </div>

                <div className='resume_analyse_tabs'>
                  {
                    analyse && (analyse.map((item) => {
                      return <div className={analysValue == item.value ? 'analyse_tabs_items' : 'analyse_tabs_item'}
                        key={item.value}
                        onClick={() => { this.setState({ analysValue: item.value }) }}
                      >
                        <div className='analyse_num'>{item.num}</div>
                        <div className='analyse_name'> {item.name}</div>
                      </div>
                    }))
                  }
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className='box_1200' style={{ paddingTop: "206px" }} >
          {
            analysValue === '1' ? <Feedback onChange={this.summary} history={this.props.history} /> : null
          }
          {
            analysValue === '2' ? <Sub /> : null
          }
          {
            analysValue === '3' ? <Favorite onChange={this.summary} data={statistic} /> : null
          }

        </div>
      </div>

    </div>
  }
}

export default personalCenter;